(function () {
    'use strict';

    angular
        .module('app')
        .controller('ProfileEditController', lController);

    function lController($scope, $rootScope, $state, UserService, SharedData, SeasonService, toaster) {
        var model = this;
        //$scope.userId = $rootScope.userId;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        //this needs a callback after save to angular's userDefaults....
        $scope.saveUser = function(profileModel) {
            UserService.saveUserProfile(profileModel).then(function () {
                    toaster.pop({ type: 'success', title: 'Success!', body: 'Settings Saved Successfully.', timeout: 5000 });                    

                }, function () {
                    toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while updating settings information. Please contact system administrator', timeout: 5000 });
                    
                });
        }

    }
})();
